import { HistogramTooltip } from './HistogramTooltip.js';
import { useClosestBinsState } from '../../../hooks/store/selectors.js';
import { HistogramDatapoints } from '../HistogramDatapoints.js';

export const HistogramInspect = () => {
  const highlightedBins = useClosestBinsState();

  if (!highlightedBins) {
    return null;
  }

  const { closestBin, closestBinsGrouped, closestBinsByVariant } =
    highlightedBins;

  return (
    <>
      <HistogramDatapoints
        closestPoint={closestBin}
        groupedPoints={closestBinsGrouped}
      />
      <HistogramTooltip
        points={closestBinsByVariant}
        closestPoint={closestBin}
      />
    </>
  );
};
